<template>
  <head> </head>
</template>

<script>
module.exports = {
  components: {},
};
</script>
